import { lazy, Suspense } from 'react'
import { Outlet, createFileRoute, redirect, useLocation } from '@tanstack/react-router'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'

const TanStackRouterDevtools = import.meta.env.DEV
  ? lazy(() => import('@tanstack/react-router-devtools').then(m => ({ default: m.TanStackRouterDevtools })))
  : () => null
import AppSidebar from '@/components/sidebar'
import { DebugProvider } from '@/lib/debug'
import { DebugBanner } from '@/components/debug-banner'
import { PriceFiltersProvider } from '@/lib/price-filters'
import { PageHeaderProvider, usePageHeaderState } from '@/lib/page-header'
import { FilterDrawer, FilterSummary } from '@/components/filter-drawer'

export const Route = createFileRoute('/_shell')({
  beforeLoad: ({ location }) => {
    if (!localStorage.getItem('access_token')) {
      throw redirect({ to: '/login', search: { redirect: location.href === '/' ? undefined : location.href } })
    }
  },
  component: ShellLayout,
})

function AnimatedOutlet() {
  const { pathname } = useLocation()
  return (
    <div key={pathname} className="animate-in fade-in duration-100 ease-out">
      <Outlet />
    </div>
  )
}

function ShellPageHeader() {
  const { title, subtitle } = usePageHeaderState()
  if (!title) return null
  return (
    <div className="min-w-0 shrink-0">
      <p className="text-sm font-semibold leading-tight text-foreground">{title}</p>
      {subtitle && <p className="text-xs text-muted-foreground">{subtitle}</p>}
    </div>
  )
}

function ShellLayout() {
  return (
    <DebugProvider>
      <PageHeaderProvider>
        <PriceFiltersProvider>
          <SidebarProvider>
            <AppSidebar />
            <SidebarInset>
              <DebugBanner />
              <header className="sticky top-0 z-10 flex h-16 shrink-0 items-center gap-3 border-b bg-background/95 backdrop-blur-sm px-6">
                <ShellPageHeader />
                <FilterSummary className="ml-auto" />
                <FilterDrawer />
              </header>
              <AnimatedOutlet />
            </SidebarInset>
            <Suspense><TanStackRouterDevtools position="bottom-right" /></Suspense>
          </SidebarProvider>
        </PriceFiltersProvider>
      </PageHeaderProvider>
    </DebugProvider>
  )
}
